/* Presentation only: reuse the purchase-dock lift, measure bottom navigation,
   and suppress mobile WhatsApp wherever its footprint would intercept a control. */
(() => {
  if (window.ptWhatsAppGuard) return;
  window.ptWhatsAppGuard = true;
  const mobile = window.matchMedia('(max-width: 767.98px)');
  const controls = 'a[href], button, input, select, textarea, summary, [role="button"], [tabindex], [data-matching-pricing], [data-fabric-pricing], .purchase-dock--visible, sticky-atc:not(.sticky-atc--out)';
  let frame;
  const visible = element => {
    const style = getComputedStyle(element);
    return style.display !== 'none' && style.visibility === 'visible' && element.getClientRects().length > 0;
  };
  const overlaps = (a, b) => a.left < b.right && a.right > b.left && a.top < b.bottom && a.bottom > b.top;
  function sync() {
    frame = null;
    const buttons = document.querySelectorAll('.whatsapp-button');
    if (!buttons.length) return;
    if (!mobile.matches) {
      buttons.forEach(button => button.removeAttribute('data-wa-safe'));
      return;
    }
    const nav = document.querySelector('.pt-browse__dock');
    let navHeight = nav && visible(nav) ? Math.max(0, window.innerHeight - nav.getBoundingClientRect().top) + 12 : 0;
    document.querySelectorAll('.purchase-dock--visible, sticky-atc:not(.sticky-atc--out)').forEach(action => {
      const rect = action.getBoundingClientRect();
      if (visible(action) && rect.top < window.innerHeight && rect.bottom > 0) {
        navHeight = Math.max(navHeight, window.innerHeight - rect.top + 12);
      }
    });
    const blocked = document.body.matches('.reveal-mobile-nav, .show-search')
      || document.documentElement.matches('.gallery-viewer-open, .pt-browse-open')
      || !!document.querySelector('.js-overlay.is-visible, .drawer[open], cart-drawer[open], .modal[open], dialog[open], .filter-container--show-filters-mobile, [open]:not(.is-closing) .modal');
    const candidates = blocked ? [] : document.querySelectorAll(controls);
    buttons.forEach(button => {
      const height = navHeight + 'px';
      if (button.style.getPropertyValue('--pt-wa-nav-height') !== height) button.style.setProperty('--pt-wa-nav-height', height);
      // Use the wrapper: its geometry is stable while the icon animates in.
      const rect = button.getBoundingClientRect();
      const footprint = { left: rect.left - 6, right: rect.right + 6, top: rect.top - 6, bottom: rect.bottom + 6 };
      // Reject distant controls before computing styles or walking their ancestors.
      const collision = Array.from(candidates).some(control => overlaps(footprint, control.getBoundingClientRect()) && !control.closest('.whatsapp-button') && visible(control));
      const safe = !blocked && !collision;
      if (button.hasAttribute('data-wa-safe') !== safe) button.toggleAttribute('data-wa-safe', safe);
    });
  }
  const schedule = () => { if (mobile.matches && !frame) frame = requestAnimationFrame(sync); };
  // Capture also covers scrolling inside drawers and dynamic collection content.
  document.addEventListener('scroll', schedule, { passive: true, capture: true });
  window.addEventListener('resize', schedule);
  mobile.addEventListener('change', () => {
    if (frame) cancelAnimationFrame(frame);
    frame = null;
    sync();
  });
  window.visualViewport?.addEventListener('resize', schedule);
  window.visualViewport?.addEventListener('scroll', schedule);
  document.addEventListener('load', schedule, true);
  // Our offset writes do not change the controls we check. Ignore them to
  // avoid a second full collision scan after the same update.
  const observer = new MutationObserver(records => {
    if (records.some(record => !(record.type === 'attributes'
      && record.attributeName === 'style'
      && record.target.matches('.whatsapp-button')))) schedule();
  });
  observer.observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'style', 'hidden', 'open', 'disabled', 'data-overlay'] });
  document.addEventListener('transitionend', schedule);
  document.addEventListener('animationend', schedule);
  sync();
})();
